import { EingangCtBatch, MandantKeyDisplayname } from '@ps-gui/claims-terminal-shared';

import { ExtractedDataSnapshot } from '../../models/extracted-values';

/**
 * Rewrites `snapshot.fields['tenant']` from the selected `uniqueKey` to the
 * corresponding `uniqueKeyAltsystem` from `ctBatch.metaData.tenants`. Required
 * for the audit-order endpoints on `EingangCtBatch`, which expect the alt-system
 * key. Throws when metaData or a matching entry is missing so the transmission
 * pipeline fails hard instead of silently sending a wrong value.
 */
export function mapTenantToAltsystem(
  ctBatch: EingangCtBatch,
  snapshot: ExtractedDataSnapshot,
): void {
  const currentUniqueKey = snapshot.fields['tenant'];
  if (typeof currentUniqueKey !== 'string' || currentUniqueKey.length === 0) {
    throw new Error(
      `Cannot map tenant to uniqueKeyAltsystem: snapshot.fields['tenant'] is empty for EingangCtBatch ${ctBatch.id}`,
    );
  }
  const mappedKey = getTenantAltsystemKey(currentUniqueKey, ctBatch.metaData?.tenants);
  if (!mappedKey) {
    throw new Error(
      `Cannot map tenant to uniqueKeyAltsystem: no metaData tenant with uniqueKey '${currentUniqueKey}' for EingangCtBatch ${ctBatch.id}`,
    );
  }
  snapshot.fields['tenant'] = mappedKey;
}

export function getTenantAltsystemKey(tenant: string, tenants?: MandantKeyDisplayname[]) {
  return tenants?.find((it) => it.uniqueKey === tenant)?.uniqueKeyAltsystem;
}
